import React, { useState } from "react";
import { WhatsAppOutlined, CloseOutlined } from "@ant-design/icons";
import "./whatsappbubble.css";

const WhatsAppBubble = () => {
  const [open, setOpen] = useState(false);

  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
  const defaultMessage = process.env.REACT_APP_WHATSAPP_MESSAGE;

  const handleChat = () => {
    const msg = encodeURIComponent(defaultMessage || "");
    window.open(`https://wa.me/${whatsappNumber}?text=${msg}`, "_blank");
  };

  return (
    <div className="wa-container">
      {open && (
        <div className="wa-box">
          <div className="wa-header">
            <span>Need help? Chat with us.</span>
            <CloseOutlined onClick={() => setOpen(false)} />
          </div>

          <div className="wa-body" onClick={handleChat}>
            <WhatsAppOutlined className="wa-icon" />
            <div className="wa-text">
              <span>Shree Vastu Management</span>
              <span>and Developers</span>
            </div>
          </div>
        </div>
      )}

      <div className="wa-fab" onClick={() => setOpen(!open)}>
        <WhatsAppOutlined />
      </div>
    </div>
  );
};

export default WhatsAppBubble;
